import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Edit } from 'react-feather';
import { observer } from 'mobx-react';
import man from '../../../../images/dashboard/user.png';
import authStorage from '../../../storages/mobx/authStorage';

const UserPanel = () => (
  <>
    <div className="sidebar-user text-center">
      <div>
        <img className="img-60 rounded-circle lazyloaded blur-up" src={authStorage.avatar || man} alt="#" />
        <div className="profile-edit">
          {/* <Link to="/app/users/editProfile"> */}
          {/*  <Edit /> */}
          {/* </Link> */}
        </div>
      </div>
      <h6 className="mt-3 f-14">{authStorage.name}</h6>
      <p>
        {authStorage.staffName}
      </p>
    </div>
  </>
);

export default observer(UserPanel);
